import type { ComponentProps } from 'react';
import { captureFlags } from '../../configure/flags-facade';
import { Bars as LegacyBars } from './legacy/Bars';
import { Bars as OptimizedBars } from './optimized/Bars';

/**
 * SCR-6633 rollout switch: ON renders the compositor-backed optimized bars,
 * OFF the pre-SCR-6633 implementation (byte-identical under `legacy/`).
 */
export const Bars = (props: ComponentProps<typeof OptimizedBars>) =>
  captureFlags.useIsOptimizedAudioBarsEnabled() ? (
    <OptimizedBars {...props} />
  ) : (
    <LegacyBars {...props} />
  );
